/**
 * Модели с переключателем «Кадры | Референсы»: у KIE первый/последний кадр и референсы взаимоисключающие,
 * поэтому виджет держит их в разных режимах (utils/seedanceMode, buildVideoPayload). Это Seedance 2.x, Wan 3.0
 * (обе версии, бэк — adapters/wan) и Kling 4.0 (кадры и референсы — две разные модели KIE, бэк — adapters/kling4).
 * Режим живёт в настройке seedanceMode — имя историческое.
 */
export function hasFrameRefModes(model: { id?: string; backendModel?: string } | null | undefined): boolean {
	const id = (model?.backendModel || model?.id || '').toLowerCase()
	return id.includes('seedance-2') || isWan3Model(model) || isKling4Model(model)
}

/** Wan 3.0: секунды видео-референсов + длительность ролика — не больше (docs KIE; backend adapters/wan, services/wan_refs). */
export const WAN_MAX_INPUT_PLUS_OUTPUT_SECONDS = 30

/** Wan 3.0 и Prime под любым именем (строка цены wan-3.0, id KIE wan/3-0-video) — как backend services/wan_refs.is_wan3. */
export function isWan3Model(model: { id?: string; backendModel?: string } | null | undefined): boolean {
	const id = (model?.backendModel || model?.id || '').toLowerCase()
	return id.includes('wan/3-0') || id.includes('wan-3')
}

/** Kling 4.0 под любым именем (строка цены kling-4.0, id KIE kling-4.0/reference-to-video) — как backend
 *  provider_routing._get_kie_adapter_name. */
export function isKling4Model(model: { id?: string; backendModel?: string } | null | undefined): boolean {
	const id = (model?.backendModel || model?.id || '').toLowerCase()
	return id.includes('kling-4')
}
